







































import { Component } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormInputPassword from '@/components/common/forms/FormInputPassword.vue';
import FormError from '@/components/common/forms/FormError.vue';
import { AdmiralForm } from '@/utils/AdmiralForm';

@Component({
  components: { FormError, FormInputPassword, FormInput, FormRow },
})
export default class ResetPasswordForm<ResetPasswordModel, ResetPasswordDto> extends AdmiralForm {}
